import { BlockProps, IBlockLocation } from '../../content-blocks/type';
import { InstaBlockProps } from './type';

interface Props {
  key: string;
  label: string;
  location: IBlockLocation;
}

export const createInstaBlock = (props: Props): InstaBlockProps => {
  return {
    type: 'insta',
    value: props.label,
    width: 20,
    height: 20,
    isVisible: false,
    x: 0,
    y: 0,
    fontSize: 12,
    isBold: false,
    isItalics: false,
    isCapsLocks: false,
    ...props,
  };
};

export function isInstaBlock(block: BlockProps): block is InstaBlockProps {
  return block.type === 'insta';
}
